const endpoints = {
	getUserNotifications: '/notifications/getUserNotifications',
	markAsReaded: '/notifications/markAsReaded'
}
export {endpoints}